import { NavLink } from "react-router-dom";
import HeroImg from "../../../assets/bg-rockys.png";
import Reveal from "../../../shared/design/Reveal";

const Hero = () => {
  return (
    <section className="px-6 pb-16 pt-28 md:px-12 md:pt-32">
      <div className="mx-auto grid max-w-[1320px] items-center gap-14 lg:grid-cols-[1.05fr_1fr]">
        {/* Left copy */}
        <div>
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-secondary-400/30 px-3.5 py-[7px] text-[12.5px] font-semibold tracking-[0.03em] text-secondary-400">
            <span className="h-[7px] w-[7px] rounded-full bg-primary-500" />
            62 guided expeditions across North America
          </div>
          <h1 className="mb-5 font-serif text-[44px] font-normal leading-[1.02] tracking-[-0.02em] md:text-[67px]">
            Discover the
            <br />
            <em className="italic text-secondary-400">untamed</em> beauty
            <br />
            of the wild.
          </h1>
          <p className="mb-7 max-w-[430px] text-[18px] leading-relaxed text-muted-200">
            Unforgettable journeys through expert guidance, small groups, and
            the kind of places maps forget. Yours to wander.
          </p>
          <div className="mb-7 flex items-center gap-[18px]">
            <NavLink
              to="/tours"
              className="inline-flex items-center gap-2.5 rounded-full bg-secondary-400 px-[26px] py-[15px] text-[15.5px] font-semibold text-white transition-colors hover:bg-ink"
            >
              Explore tours <span className="text-[18px]">→</span>
            </NavLink>
            <NavLink
              to="/tours"
              className="inline-flex items-center gap-2.5 text-[15px] font-semibold text-ink"
            >
              <span className="inline-flex h-[42px] w-[42px] items-center justify-center rounded-full border-[1.5px] border-ink">
                ▶
              </span>
              Watch film
            </NavLink>
          </div>
          <div className="flex items-center gap-3.5">
            <div className="flex">
              <span className="h-[34px] w-[34px] rounded-full border-2 border-sand bg-primary-500" />
              <span className="-ml-3 h-[34px] w-[34px] rounded-full border-2 border-sand bg-secondary-400" />
              <span className="-ml-3 h-[34px] w-[34px] rounded-full border-2 border-sand bg-secondary-100" />
            </div>
            <div className="text-[13.5px] text-muted-200">
              <b className="text-ink">2,400+ wanderers</b> · ★ 4.9 average
            </div>
          </div>
        </div>

        {/* Right image */}
        <div className="relative h-[440px] md:h-[520px]">
          <div className="absolute inset-0 overflow-hidden rounded-[26px] shadow-[0_40px_80px_-30px_rgba(19,58,69,0.5)]">
            <img
              src={HeroImg}
              alt="Mountain expedition"
              className="h-full w-full object-cover"
            />
            <span className="absolute right-4 top-4 rounded-full bg-sand/90 px-3 py-[7px] text-[12.5px] font-bold text-secondary-400">
              ★ 4.9 · Banff
            </span>
          </div>
          <div className="absolute -bottom-[18px] -left-[22px] z-10 flex items-center gap-[18px] rounded-2xl bg-ink px-5 py-4 text-sand shadow-[0_24px_44px_-18px_rgba(0,0,0,0.45)]">
            <div>
              <div className="text-[11px] font-bold tracking-[0.14em] text-primary-500">
                NEXT DEPARTURE
              </div>
              <div className="mt-[3px] font-serif text-[21px]">Banff · Jun 14</div>
            </div>
            <div className="h-[38px] w-px bg-white/20" />
            <div>
              <div className="text-[11px] text-muted-300">from</div>
              <div className="text-[18px] font-extrabold">$3,120</div>
            </div>
          </div>
        </div>
      </div>

      {/* Search bar */}
      <Reveal>
        <div className="mx-auto mt-16 grid max-w-[920px] grid-cols-1 items-center gap-2 rounded-[18px] bg-white p-2.5 pl-[26px] shadow-[0_30px_60px_-28px_rgba(0,0,0,0.3)] sm:grid-cols-[1.3fr_1fr_1fr_auto]">
          <div className="py-2">
            <div className="text-[11px] font-bold tracking-[0.1em] text-muted-300">
              DESTINATION
            </div>
            <div className="mt-0.5 text-[15px] font-semibold">Anywhere wild</div>
          </div>
          <div className="py-2 sm:border-l sm:border-line-200 sm:pl-[22px]">
            <div className="text-[11px] font-bold tracking-[0.1em] text-muted-300">
              WHEN
            </div>
            <div className="mt-0.5 text-[15px] font-semibold">Summer 2026</div>
          </div>
          <div className="py-2 sm:border-l sm:border-line-200 sm:pl-[22px]">
            <div className="text-[11px] font-bold tracking-[0.1em] text-muted-300">
              TRAVELERS
            </div>
            <div className="mt-0.5 text-[15px] font-semibold">2 adults</div>
          </div>
          <NavLink
            to="/tours"
            className="rounded-xl bg-primary-500 px-[30px] py-[18px] text-center text-[15px] font-bold text-ink transition-colors hover:bg-primary-300"
          >
            Search
          </NavLink>
        </div>
      </Reveal>
    </section>
  );
};

export default Hero;
